import { createStyles } from "@mantine/emotion";

export const useStylesStampResult = createStyles((theme) => ({
  stamp: {
    paddingBottom: "0",
    paddingTop: theme.spacing.stamp.padding.top.main,
    h1: {
      fontSize: theme.spacing.stamp.fontSize.title,
      lineHeight: theme.spacing.stamp.lineHeight.title,
      fontFamily: theme.headings.fontFamily.primary,
      textAlign: "center",
      marginTop: "0",
      marginBottom: theme.spacing.stamp.margin.bottom.title,
    },
    "&.stamp-result--duplicate-warning": {
      h1: {
        marginBottom:
          theme.spacing.stamp.duplicateStampWarning.titleMarginBottom,
      },
    },
    ".block": {
      backgroundColor: theme.customColors.white,
      boxShadow: "0 0 1.333em rgba(0,0,0,.161)",
      flexGrow: "0",
      marginTop: theme.spacing.stamp.margin.bottom.block,
      maxWidth: theme.spacing.stamp.width.max,
      overflow: "hidden",
      paddingBottom: theme.spacing.stamp.padding.top.bottom,
      paddingTop: theme.spacing.stamp.padding.top.block,
      position: "relative",
      marginLeft: "auto",
      marginRight: "auto",
      width: theme.spacing.stamp.width.block,

      [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
        paddingTop: theme.spacing.stamp.padding.top.blockDesktop,
      },
      ".scalloped-top, .scalloped-bottom": {
        position: "absolute",
        background:
          "radial-gradient(ellipse at center, rgba(0, 0, 0, 0.14) 40%, #E4E4E4 50%, transparent 0%)",
        backgroundSize: theme.spacing.stamp.background.size.scallopedTop,
        backgroundRepeat: "repeat-x",
        width: "100%",
        height: theme.spacing.stamp.height.scalloped,
        left: theme.spacing.stamp.position.scalloped.left,
        maxWidth: `calc(100% - ${theme.spacing.stamp.position.scalloped.offset})`,
      },

      ".scalloped-left, .scalloped-right": {
        position: "absolute",
        background:
          "radial-gradient(ellipse at center, rgba(0, 0, 0, 0.14) 40%, #E4E4E4 50%, transparent 0%)",
        backgroundSize: theme.spacing.stamp.background.size.scallopedSide,
        backgroundRepeat: "repeat-y",
        width: theme.spacing.stamp.height.scalloped,
        height: "100%",
        top: theme.spacing.stamp.position.scalloped.top,
        maxHeight: `calc(100% - ${theme.spacing.stamp.position.scalloped.offset})`,
      },

      ".scalloped-top": {
        top: `-${theme.spacing.stamp.position.scalloped.offset}`,
      },

      ".scalloped-bottom": {
        bottom: `-${theme.spacing.stamp.position.scalloped.offset}`,
      },

      ".scalloped-left": {
        left: `-${theme.spacing.stamp.position.scalloped.offset}`,
      },

      ".scalloped-right": {
        right: `-${theme.spacing.stamp.position.scalloped.offset}`,
      },
    },
    ".buttonBlack-verify": {
      paddingLeft: theme.spacing.stamp.padding.button.left,
      paddingRight: theme.spacing.stamp.padding.button.right,
      height: theme.spacing.stamp.height.button,
    },
    ".download-pdf": {
      background: "none",
      border: "none",
      paddingLeft: "0",
    },

    ".file-found-header": {
      marginBottom: theme.spacing.stamp.fileFoundHeader.marginBottom,
      textAlign: "center",
      h1: {
        marginBottom: theme.spacing.stamp.fileFoundHeader.h1.marginBottom,
        lineHeight: theme.spacing.stamp.fileFoundHeader.h1.lineHeight,
        fontFamily: theme.headings.fontFamily.bold,
      },
      ".block-file-found": {
        maxWidth: theme.spacing.stamp.fileFoundBlock.maxWidth,
        marginLeft: "auto",
        marginRight: "auto",

        h1: {
          fontFamily: theme.headings.fontFamily.bold,
          fontSize: theme.spacing.stamp.fileFoundBlock.h1.fontSize,
        },
      },
      ".h1-file-found": {
        marginTop: theme.spacing.stamp.margin.top.title,
      },
    },
    ".file-found-header-text": {
      marginBottom: theme.spacing.stamp.margin.bottom.headerText,
      "&.file-found-header-text": {
        marginBottom: "0",
      },
    },

    ".file-found-header-link": {
      alignItems: "center",
      marginRight: "auto",
      marginLeft: "auto",
      justifyContent: "center",
      display: "flex",
      marginTop: theme.spacing.stamp.text.fileFoundHeaderLink.marginTop,
      maxWidth: theme.spacing.stamp.text.fileFoundHeaderLink.maxWidth,
      textAlign: "center",
      gap: theme.spacing.stamp.text.fileFoundHeaderLink.gap,
      fontSize: theme.spacing.stamp.text.fileFoundHeaderLink.fontSize,
      p: {
        fontSize: theme.spacing.stamp.text.fileFoundHeaderLink.text.fontSize,
        marginRight:
          theme.spacing.stamp.text.fileFoundHeaderLink.text.marginRight,
        fontFamily: theme.headings.fontFamily.bold,
      },
      a: {
        fontSize: theme.spacing.stamp.text.fileFoundHeaderLink.link.fontSize,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        svg: {
          marginRight:
            theme.spacing.stamp.text.fileFoundHeaderLink.svg.marginRight,
        },
      },
      ".file-found-header-link-text": {
        textTransform: "lowercase",
        color: theme.customColors.blackLight,
        fontSize: theme.spacing.stamp.text.fileFoundHeaderLink.link.fontSize,
        paddingLeft:
          theme.spacing.stamp.text.fileFoundHeaderLink.link.paddingLeft,
        fontFamily: theme.headings.fontFamily.primary,
        span: {
          textTransform: "uppercase",
          fontSize: theme.spacing.stamp.text.fileFoundHeaderLink.link.fontSize,
        },
      },
      "&.file-found-header-link-block": {
        display: "flex",
        alignItems: "center",
        gap: "0",
        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          display: "block",
        },
        p: {
          fontSize: theme.spacing.stamp.text.fileFoundHeaderLink.link.fontSize,
        },
      },
    },

    ".file-found-header-link-without-link-id": {
      marginBottom:
        theme.spacing.stamp.text.fileFoundHeaderLinkWithoutLinkId.marginBottom,
    },
    ".duplicate-stamp-warning": {
      alignItems: "flex-start",
      backgroundColor: theme.customBackgrounds.duplicateStampWarning,
      border: theme.customColors.diyBorder,
      borderRadius: theme.spacing.common.borderRadius,
      color: theme.customColors.black,
      gap: theme.flex.gap.xs,
      marginBottom: theme.spacing.stamp.duplicateStampWarning.marginBottom,
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: theme.spacing.borderedContent.maxWidth,
      padding: theme.spacing.stamp.duplicateStampWarning.padding,
      width: theme.spacing.stamp.width.block,

      [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
        maxWidth: theme.spacing.borderedContent.maxWidthMobile,
        width: theme.spacing.borderedContent.maxWidthMobile,
      },
    },
    ".duplicate-stamp-warning__icon": {
      color: theme.customColors.black,
      flexShrink: "0",
      height: theme.spacing.stamp.duplicateStampWarning.iconSize,
      marginTop: theme.spacing.stamp.duplicateStampWarning.iconMarginTop,
      width: theme.spacing.stamp.duplicateStampWarning.iconSize,
    },
    ".duplicate-stamp-warning__text": {
      color: theme.customColors.black,
      fontFamily: theme.headings.fontFamily.primary,
      fontSize: theme.spacing.stamp.duplicateStampWarning.fontSize,
      lineHeight: theme.spacing.stamp.duplicateStampWarning.lineHeight,
      margin: "0",
    },
    ".duplicate-stamp-warning__lead": {
      fontFamily: theme.headings.fontFamily.bold,
      fontSize: theme.spacing.stamp.duplicateStampWarning.leadFontSize,
    },
    ".file-found-buttonBlack-verify": {
      textDecoration: "none",
      height: "auto",
      fontWeight: "bold",
    },
    ".file-found_bottom": {
      marginRight: "auto",
      marginLeft: "auto",
      maxWidth: theme.spacing.stamp.fileFoundBottom.maxWidth,
      marginTop: theme.spacing.stamp.fileFoundBottom.marginTop,
    },
    ".file-found_bottom-title": {
      fontFamily: theme.headings.fontFamily.bold,
      fontSize: theme.spacing.stamp.fileFoundBottom.title.fontSize,
      marginBottom: theme.spacing.stamp.fileFoundBottom.title.marginBottom,
    },
    ".file-found_bottom-text": {
      b: {
        fontFamily: theme.headings.fontFamily.bold,
      },
    },
    ".file-found_bottom-text-last": {
      fontFamily: theme.headings.fontFamily.bold,
      textAlign: "center",
      marginTop: theme.spacing.stamp.fileFoundBottom.textLast.marginTop,
    },
    "&.stamp-created-text": {
      h1: {
        marginBottom: theme.spacing.stamp.text.h1.marginBottom,
      },
    },
    ".file-found-preview-container": {
      paddingLeft: theme.spacing.stamp.text.fileFoundPreview.container.padding,
      paddingRight: theme.spacing.stamp.text.fileFoundPreview.container.padding,
      paddingTop: theme.spacing.stamp.text.fileFoundPreview.container.padding,
    },
    ".file-found-preview": {
      maxWidth: theme.spacing.stamp.text.fileFoundPreview.maxWidth,
      justifyContent: "center",
      marginRight: "auto",
      marginLeft: "auto",
      marginTop: theme.spacing.stamp.text.fileFoundPreview.marginTop,

      textAlign: "left",
    },
    ".file-found-preview-title": {
      fontFamily: theme.headings.fontFamily.bold,
      fontSize: theme.spacing.stamp.text.fileFoundPreview.title.fontSize,
    },
    ".file-found-preview-text": {
      maxHeight: theme.spacing.stamp.text.fileFoundPreview.content.maxHeight,
      overflow: "auto",
      backgroundColor: theme.customColors.white,
      padding: theme.spacing.stamp.text.fileFoundPreview.content.padding,
    },
    ".file-found-preview-img": {
      maxHeight: theme.spacing.stamp.text.fileFoundPreview.content.maxHeight,
      overflow: "auto",
      padding: theme.spacing.stamp.text.fileFoundPreview.content.padding,
      img: {
        maxWidth: "100%",
      },
    },
    ".mantine-Alert-wrapper": {
      paddingLeft: theme.spacing.stamp.text.fileFoundPreview.alert.padding,

      ".mantine-Alert-title": {
        fontWeight: "normal",
      },
    },
    ".verified-downloaded-link": {
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: theme.spacing.stamp.width.max,
      marginTop: theme.spacing.stamp.text.fileFoundHeaderLink.marginTop,
      marginBottom: theme.spacing.stamp.text.fileFoundHeaderLink.marginBottom,
      textAlign: "center",
      p: {
        fontSize: theme.spacing.stamp.text.fileFoundHeaderLink.fontSize,
      },
      ".mantine-ActionIcon-root": {
        top: "0",
      },
    },

    ".verified-downloaded-link-loader": {
      marginBottom: theme.spacing.stamp.text.fileFoundHeaderLink.marginBottom,
      marginLeft: "auto",
      marginRight: "auto",
      display: "block",
    },
    h2: {
      textAlign: "center",
      fontSize: theme.spacing.stamp.h2.fontSize,
      fontFamily: theme.headings.fontFamily.bold,
      marginBottom: theme.spacing.stamp.h2.marginBottom,
    },
    ".error-item": {
      marginBottom: theme.spacing.stamp.errorTechnicalDetails.marginBottom,
    },
  },
}));
